import { provideChameleonDesignSystem } from '../provideChameleonDesignSystem';
import { chameleonTabs } from './Tabs.definition';
import { chameleonTab } from './Tab/Tab.definition';
import { chameleonTabPanel } from './TabPanel/TabPanel.definition';
export function registerCustom(prefix, node) {
    return provideChameleonDesignSystem({ prefix, node }).register(chameleonTab({ prefix }), chameleonTabPanel({ prefix }), chameleonTabs({ prefix }));
}
